import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { chatRoute } from '@townsquare/routes/chat';
import { createAgentRoute } from '@townsquare/routes/create-agent';
import { editAgentRoute } from '@townsquare/routes/edit-agent';
import { sharedConversationPreviewRoute } from '@townsquare/routes/shared-conversation-preview';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

import { ChatLoadable } from './components/ChatView';
import { CreateAgentLoadable } from './components/CreateAgentView';
import { EditAgentLoadable } from './components/EditAgentView';
import { SharedConversationPreviewLoadable } from './components/SharedConversationPreviewView/SharedConversationPreviewLoadable';

chatRoute.component = ChatLoadable;
chatRoute.resources = [rovoEntitlementResource];
export const chatRouterRoute: GlobalHomePageRoute = chatRoute;

createAgentRoute.component = CreateAgentLoadable;
createAgentRoute.resources = [rovoEntitlementResource];
export const createAgentRouterRoute: GlobalHomePageRoute = createAgentRoute;

editAgentRoute.component = EditAgentLoadable;
editAgentRoute.resources = [rovoEntitlementResource];
export const editAgentRouterRoute: GlobalHomePageRoute = editAgentRoute;

sharedConversationPreviewRoute.component = SharedConversationPreviewLoadable;
sharedConversationPreviewRoute.resources = [rovoEntitlementResource];
export const sharedConversationPreviewRouterRoute: GlobalHomePageRoute =
	sharedConversationPreviewRoute;

export const isInRovoFullscreenPages = (routeName: string): boolean =>
	// Shared preview uses the Home fullscreen shell but keeps the default Home side nav.
	routeName === chatRoute.name ||
	routeName === createAgentRoute.name ||
	routeName === editAgentRoute.name;
